import { InfoNote, InfoNoteThreatLevel } from "@app2/type-defs/metadata/metadata-types";

const THREAT_LEVEL_RANKS = { ZERO: 0, ONE: 1, TWO: 2, THREE: 3 };

export function getHighestInfoNoteThreatLevel(notes: InfoNote[]): InfoNoteThreatLevel {
    let highestThreatLevel;
    for (const note of notes) {
        if (!highestThreatLevel || (THREAT_LEVEL_RANKS[note.threatLevel] > THREAT_LEVEL_RANKS[highestThreatLevel])) {
            highestThreatLevel = note.threatLevel;
        }
    }
    return highestThreatLevel;
}